import { menu as v1Menu } from '../../api/v1/auth';
import { getSession } from '../../core/apiV1';

export async function getMenu() {
   let menu = null;
   try {
      menu = JSON.parse(window.localStorage.getItem('menusr'));
   } catch (e) {
      menu = null;
   }
   if (menu) {
      this.setState({ menu: menu });
      return menu;
   }
   if (!getSession().token) return [];
   menu = await v1Menu();
   localStorage.setItem('menusr', JSON.stringify(menu));
   this.setState({ menu: menu });
   return menu;
}
